module.exports = __webpack_public_path__ + "static/media/tag-bg-full-pulsating.829f8588.svg";